<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <mat-card-content>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                                <input matInput id="txtSiteRecebimento" #txtEspecie maxlength="10"
                                    formControlName="Site_recebimento" [readonly]="isReadyOnly"
                                    [class.InputBlockColor]="isReadyOnly">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>

                                <mat-select multiple #txtSafra formControlName="Safra" disableCenteringOption
                                    (openedChange)="openedChangeSafra($event, 'SafraSeracher')"
                                    (selectionChange)="selectionSafraChange($event)">
                                    <input matInput type="text" formControlName="SafraSeracher"
                                        class="form-control filterTxt" placeholder="Pesquisar por..."
                                        (keyup)="createFilterSafra($event.target.value)">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name"
                                        (onSelectionChange)="selectionChange($event, selectedSafraList)">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                            floatLabel="{{ formFieldFloatLabel }}">
                            <mat-label class="InputLabelColor">Híbrido</mat-label>
                            
                            <mat-select #txtHibrido formControlName="Hibrido_rnc_linhagem" disableCenteringOption
                                        (selectionChange)="selectionHibridoChange($event)">
                                
                                <input matInput type="text" class="form-control filterTxt"
                                    placeholder="Pesquisar por..."
                                    (keyup)="createFilterHibrido($event.target.value)" />
                                
                                <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                                {{ item.name | uppercase }}
                                </mat-option>
                                
                            </mat-select>
                            <i matSuffix class="{{ iconEnableField }}"></i>
                            <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>

                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                            floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                                <mat-select multiple #txtLoteDs formControlName="Lote_ds" disableCenteringOption
                                    (openedChange)="openedChangeLote($event, 'LoteSearcher')"
                                    (blur)="checkMaxSelection()">
                                    <input matInput type="text" formControlName="LoteSearcher"
                                        class="form-control filterTxt" placeholder="Pesquisar por..."
                                        (keyup)="createFilterLoteDs($event.target.value)">
                                    <mat-checkbox *ngIf="isComercial" class="mat-option"  [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()">
                                        Selecionar tudo
                                    </mat-checkbox>
                        
                                    <mat-option *ngFor="let item of listLoteDs" [value]="item.lote_ds"
                                        (onSelectionChange)="selectionChange($event, selectedLoteList)">
                                        {{item.lote_ds | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error *ngIf="selectedLoteList.length > 24">
                                    O limite de itens selecionados é 24.
                                </mat-error>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Peneiras</mat-label>
                                <mat-select #txtHibrido formControlName="Peneiras" disableCenteringOption>
                                    <mat-option *ngFor="let item of listPeneiras" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Prioridade no sequenciamento</mat-label>
                                <mat-select #txtPrioridadeSequenciamento formControlName="PrioridadeSequenciamento"
                                    [(ngModel)]="selectedPrioridadeSequenciamento" disableCenteringOption 
                                    [(value)]="selectedPrioridadeSequenciamento">
                                    <mat-option *ngFor="let item of listPrioridadesSequenciamento" [value]="item.value">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-card class="card" *ngIf="enablePrioridadesSequenciamento">
                        <mat-card-header>
                            <mat-card-subtitle>
                                Selecione abaixo quais lotes deverão seguir regras de segregação. Os lotes que ficarem sem seleção serão considerados no 
                                sequenciamento junto com lotes faixa livre.
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div>
                                <table mat-table [dataSource]="dataSourceByRegraSegregacao" class="w-100" border="1">
                                    <!-- Checkbox Column -->
                                    <ng-container matColumnDef="select" class="checkbox-select">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let row" class="coluna-1">
                                            <mat-checkbox [checked]="allComplete"
                                                (change)="verificarLotesRegraSegragacao($event, row.lote_ds, row.faixa_fisiologica)">
                                            </mat-checkbox>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Lotes">
                                        <th mat-header-cell *matHeaderCellDef> Lotes </th>
                                        <td mat-cell *matCellDef="let element" class="coluna-2"> 
                                            <span class="checkbox">
                                                {{element.lote_ds}}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="FaixaGenetica">
                                        <th mat-header-cell *matHeaderCellDef> Faixas genéticas </th>
                                        <td mat-cell *matCellDef="let element"
                                            class="formatFieldReport formatCellReport coluna-2"
                                            [ngClass]="formatFaixasGenetica(element)">
                                            <span class="checkbox">
                                                {{element.faixa_genetica}}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="FaixaFisiologica">
                                        <th mat-header-cell *matHeaderCellDef> Faixas fisiológicas </th>
                                        <td mat-cell *matCellDef="let element"
                                            class="formatFieldReport formatCellReport coluna-2"
                                            [ngClass]="formatFaixasFisiologica(element)">
                                            <div>{{element.faixa_fisiologica}}</div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="symbol">
                                        <th mat-header-cell *matHeaderCellDef> Symbol </th>
                                        <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsByRegraSegregacao"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsByRegraSegregacao;"></tr>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell text-center" colspan="100%"><i
                                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum
                                            registro
                                            encontrado</td>
                                    </tr>
                                </table>
                            </div>
                        </mat-card-content>
                    </mat-card><br>

                    <mat-card *ngIf="isMisturarTonsAzul">
                        <section class="example-section">
                            <div mat-dialog-content class="texto-segregacao">
                                <span class="margin">Para os lotes faixa azul que serão segregados, foi autorizado misturar tons diferentes de faixa azul (claro, escuro, campo, etc)?</span>
                            </div>
                            <mat-radio-group formControlName="MisturarTonsAzul">
                              <mat-radio-button class="margin" value="N">Não</mat-radio-button>
                              <mat-radio-button class="margin" value="S">Sim</mat-radio-button>
                            </mat-radio-group>
                          </section>
                    </mat-card><br>

                    <div class="col-lg col-md col-xs col-sm col-xl text-right">
                        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Buscar"
                            [hidden]="!enableButtons | async" (click)="buildReports($event)">
                            <i class="fa fa-search" aria-hidden="true"></i> Buscar
                        </button>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>